import { Component, EventEmitter, OnInit, OnDestroy, Output, ChangeDetectionStrategy, ChangeDetectorRef, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Subscription } from 'rxjs';
import { GtwSnackbarService } from '../../../shared/_services/gtw-snackbar.service';
import { Form4562Service } from './form4562.service';
import { GlobalService } from '../../../global/services/global.service';
import { WorkspaceService } from '../../../workspace/workspace.service';
import { AppService } from '../../../app.service';
import {
  buildHeaderDataShell,
  generalConfigFromGlobal,
  normalizeFilterParams,
  rowPayloadFromActiveScreen
} from '../../../shared/workspace-element-context';

@Component({
    selector: 'gtw-form4562',
    templateUrl: './form4562.component.html',
    styleUrls: ['./form4562.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class Form4562Component implements OnInit, OnDestroy {
  private readonly destroyRef = inject(DestroyRef);


  @Output('request-grid-update') requestGridUpdate = new EventEmitter<string>();

  private readonly subs = new Subscription();
  private isInitialized = false;

  baseURLs: any = {};
  globalService: any = {};
  USER_SETTINGS: any = {};
  SERVER_CONFIG: any = {};
  GENERAL_CONFIG: any = {};
  filterParams: any = {};
  rowData: any = {};

  modalTitle = 'Form 4562: Depreciation & Amortization';
  minimise = false;
  isSaveClicked = false;
  crudLoading = false;
  showFormLoader = true;
  currentTabName = 'Form Entry';

  activeTab = 1;
  tabs = [{ id: 1, name: 'Form Entry' }, { id: 2, name: 'Form View' }];

  /** Raw load response and processed form state */
  formData: any;
  jsonData: any;
  form4562Data: any[] = [];
  assetsPlacedService: any[] = [];
  bonusApplied: any[] = [];
  methodAdopted: any[] = [];
  serDuringCurrYear: string | null = null;
  AssetsCurrentYear = true;
  IsBonus: string | null = null;
  MethodAdopted: string | null = null;
  form4562DepExpPerTaxRet: any[] = [];
  form4562line14: any[] = [];
  form4562line16: any[] = [];
  form4562line17: any[] = [];
  form4562line25: any[] = [];
  form4562line43: any[] = [];
  line14Amt: number = 0;
  line16Amt: number = 0;
  line17Amt: number = 0;
  line25Amt: number = 0;
  line43Amt: number = 0;
  line19Headers: any[] = [];
  line26Headers: any[] = [];
  line42Headers: any[] = [];
  line19DetHeader: any[] = [];
  line20DetHeader: any[] = [];
  line19AllDetails: any[] = [];
  line20AllDetails: any[] = [];
  totalDepExpPer4562: any[] = [];
  unallocatedAmt: any[] = [];
  totAmortAmtPerTaxRet: any[] = [];
  form4562Line26Records: any[] = [];
  form4562Line42Records: any[] = [];
  form4562Line26RecordsCopy: any[] = [];
  form4562Line42RecordsCopy: any[] = [];
  form4562Line42RecordsOrig: any[] = [];
  displayViewValue_26: boolean[] = [];
  displayEditValue_26: boolean[] = [];
  displayViewValue_42: boolean[] = [];
  displayEditValue_42: boolean[] = [];
  displayDeleteIcon_26: boolean[] = [];
  displayDeleteIcon_42: boolean[] = [];
  depreDed26 = 0;
  v_form_key = 3;
  form4562Amounts: any[][] = [[], []];
  temp02 = 0;
  temp2E = 0;
  temp10E = 0;

  /** Static data (labels, options) - matches AngularJS $scope.data */
  data: any = {
    partII: { title: 'Special Depreciation Allowance and Other Depreciation', tableTitle: 'Special depreciation allowance for qualified property (other than listed property) placed in service during the tax year', tableData: [] },
    partIII: { title: 'MACRS Depreciation', table: { num: '17', value: 'MACRS deductions for assets placed in service in tax years beginning before 2017' }, convensions: ['HY', 'MM', 'MQ', 'S/L'], methods: ['150 DB', '200 DB', 'DB', 'S/L'], sections: [] },
    partV: { title: 'Listed Property', tableTitle: 'Section A-Depreciation and Other Information', tableHeaders: [], tableData: [], rows: [] },
    partVI: { title: 'Amortization', tableHeaders: [], tableData: [], rows: [] },
    selectPeriod: ['3', '5', '7', '10', '15', '20', '25', '27.5', '39', '50'],
    selectPeriodStr: ['3 Yrs', '5 Yrs', '7 Yrs', '10 Yrs', '15 Yrs', '20 Yrs', '25 Yrs', '27.5 Yrs', '39 Yrs', '50 Yrs'],
    selectMethod: ['DB', 'S/L', '150 DB', '200 DB'],
    selectConvention: ['HY', 'MM', 'MQ', 'S/L']
  };

  formData_26: any = { addrows: [], editrows: [], removerows: [] };
  formData_42: any = { addrows: [], editrows: [], removerows: [] };
  formData_line14: any = { editrows: [] };
  formData_line16: any = { editrows: [] };
  formData_line17: any = { editrows: [] };
  formData_line25: any = { editrows: [] };
  formData_line43: any = { editrows: [] };
  formData_19: any[] = [];
  formData_20: any[] = [];

  /** Form View tab static data */
  FormViewData: any = {};

  taxYear = 0;
  scenario = 0;
  jcd = 250;
  combinationKey = 0;
  groupObjKey = 0;
  recordData_26: any[] = [];
  recordData_42: any[] = [];

  constructor(
    private gtwGlobal: GlobalService,
    private gtwWorkspace: WorkspaceService,
    private gtwApp: AppService,
    private cdr: ChangeDetectorRef,
    private gtwSnackbarService: GtwSnackbarService,
    private form4562Service: Form4562Service
  ) {
    this.initFormViewData();
  }

  ngOnInit(): void {
    this.applyWorkspaceContext();
    this.subs.add(this.gtwWorkspace.setTabActive.subscribe(() => { this.applyWorkspaceContext(); this.tryInit(); }));
    this.subs.add(this.gtwGlobal.globalParamsChanged$.subscribe(() => { this.applyWorkspaceContext(); this.tryInit(); }));
    this.tryInit();
  }

  ngOnDestroy(): void { this.subs.unsubscribe(); }

  private applyWorkspaceContext(): void {
    const activeScreen = this.gtwWorkspace.workspaceFactory?.activeScreen || {};
    const header = buildHeaderDataShell(this.gtwGlobal, this.gtwApp);
    this.baseURLs = generalConfigFromGlobal(this.gtwGlobal);
    this.globalService = header.globalParams || header;
    this.USER_SETTINGS = header.userSettingsData || {};
    this.SERVER_CONFIG = header.serverConfigData || {};
    this.GENERAL_CONFIG = header.generalConfigData || {};
    this.filterParams = normalizeFilterParams(activeScreen);
    this.rowData = rowPayloadFromActiveScreen(activeScreen);
    this.cdr.detectChanges();
  }

  private tryInit(): void {
    if (this.isInitialized) return;
    if (!this.rowData || Object.keys(this.rowData).length === 0) return;
    if (!this.GENERAL_CONFIG?.base_url) return;
    this.isInitialized = true;
    this.init();
  }

  private init(): void {
    this.modalTitle = 'Form 4562: Depreciation & Amortization - Debit (Credit) Format';
    this.taxYear = parseInt(this.rowData.TAX_YEAR, 10) || 0;
    this.scenario = parseInt(String(this.rowData.SCENARIO), 10) || 0;
    this.jcd = this.rowData.JCD_KEY ?? 250;
    this.combinationKey = parseInt(String(this.rowData.COMBINATION_KEY || 0), 10) || 0;
    this.groupObjKey = parseInt(String(this.rowData.GROUP_OBJ_KEY || 0), 10) || 0;
    if (this.taxYear < 2016) this.AssetsCurrentYear = false;
    this.data.partV.rows = [];
    this.data.partVI.rows = [];
    this.buildRecordData26And42();
    this.loadData();
  }

  private buildRecordData26And42(): void {
    const base = { tax_year: this.taxYear, trans_type_key: 9, combination_key: this.combinationKey, group_obj_key: 201473, form_key: 3, trans_dtls_key: null, trans_status: 'A', is_dirty: 'N' };
    this.recordData_26 = [
      { ...base, line_no: 26, occurence: null, line_attrib_key: 444, Attribute_Name: 'PROPERTY_DESC', Attribute_Value: null },
      { ...base, line_no: 26, occurence: null, line_attrib_key: 445, Attribute_Name: 'DATE_PLACED_SERVICE', Attribute_Value: new Date() },
      { ...base, line_no: 26, occurence: null, line_attrib_key: 446, Attribute_Name: 'BUSINESS_PERCENT', Attribute_Value: 0 },
      { ...base, line_no: 26, occurence: null, line_attrib_key: 447, Attribute_Name: 'COST_BASIS', Attribute_Value: 0 },
      { ...base, line_no: 26, occurence: null, line_attrib_key: 448, Attribute_Name: 'BASIS_DEPRECIATION', Attribute_Value: 0 },
      { ...base, line_no: 26, occurence: null, line_attrib_key: 449, Attribute_Name: 'RECOVERY_PERIOD', Attribute_Value: '3' },
      { ...base, line_no: 26, occurence: null, line_attrib_key: 450, Attribute_Name: 'METHOD_OR_CONVENTION', Attribute_Value: 'DB' },
      { ...base, line_no: 26, occurence: null, line_attrib_key: 450, Attribute_Name: 'METHOD_OR_CONVENTION', Attribute_Value: 'HY' },
      { ...base, line_no: 26, occurence: null, line_attrib_key: 2180, Attribute_Name: 'SEC_179_COST', Attribute_Value: 0 },
      { ...base, line_no: 26, occurence: null, line_attrib_key: 451, Attribute_Name: 'DEPRECIATION_DEDUCTION', Attribute_Value: 0 }
    ];
    this.recordData_42 = [
      { ...base, line_no: 42, occurence: null, line_attrib_key: 468, Attribute_Name: 'DESCRIPTION_COSTS', Attribute_Value: null },
      { ...base, line_no: 42, occurence: null, line_attrib_key: 469, Attribute_Name: 'DATE_AMORTIZATION_BEGINS', Attribute_Value: new Date() },
      { ...base, line_no: 42, occurence: null, line_attrib_key: 470, Attribute_Name: 'AMORTIZATION_AMOUNT', Attribute_Value: 0 },
      { ...base, line_no: 42, occurence: null, line_attrib_key: 471, Attribute_Name: 'CODE_SECTION', Attribute_Value: 0 },
      { ...base, line_no: 42, occurence: null, line_attrib_key: 472, Attribute_Name: 'AMORTIZATION_PERIOD_OR_PTG', Attribute_Value: null },
      { ...base, line_no: 42, occurence: null, line_attrib_key: 473, Attribute_Name: 'AMORTIZATION_FOR_THIS_YEAR', Attribute_Value: 0 }
    ];
  }

  private loadData(): void {
    const baseUrl = this.GENERAL_CONFIG?.base_url || this.baseURLs?.api || '';
    this.showFormLoader = true;
    this.cdr.detectChanges();
    this.form4562Service.loadFormData(baseUrl, this.rowData).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (data: any) => {
        const irsForm = data?.irsForm;
        if (irsForm?.callSuccess && irsForm.callSuccess !== '1') {
          this.gtwSnackbarService.openSnackBar(data?.errorMessage || 'Error loading form data', 'gtw-snackbar--red');
        } else {
          this.formData = data;
          this.processFormData(data);
        }
        this.showFormLoader = false;
        this.cdr.detectChanges();
      },
      error: () => {
        this.gtwSnackbarService.openSnackBar('Error loading form data', 'gtw-snackbar--red');
        this.showFormLoader = false;
        this.cdr.detectChanges();
      }
    });
  }

  private processFormData(data: any): void {
    if (!data?.irsForm?.formItemList) return;
    const list = data.irsForm.formItemList;
    this.jsonData = data;
    this.form4562Data = list;
    this.assetsPlacedService = list[1]?.dataRowList?.[0]?.dataCellList || [];
    this.bonusApplied = list[2]?.dataRowList?.[0]?.dataCellList || [];
    this.methodAdopted = list[3]?.dataRowList?.[0]?.dataCellList || [];
    this.form4562DepExpPerTaxRet = list[4]?.dataRowList?.[0]?.dataCellList || [];
    if (this.rowData?.TB_AMT != null) {
      this.form4562DepExpPerTaxRet[1] = this.form4562DepExpPerTaxRet[1] || {};
      (this.form4562DepExpPerTaxRet[1] as any).value = this.rowData.TB_AMT;
    } else if (this.form4562DepExpPerTaxRet[1]) {
      (this.form4562DepExpPerTaxRet[1] as any).value = 0;
    }
    this.form4562line14 = list[6]?.dataRowList?.[0]?.dataCellList || [];
    this.form4562line16 = list[7]?.dataRowList?.[0]?.dataCellList || [];
    this.form4562line17 = list[9]?.dataRowList?.[0]?.dataCellList || [];
    this.line14Amt = parseInt(String((this.form4562line14[2] as any)?.value ?? 0), 10) || 0;
    this.line16Amt = parseInt(String((this.form4562line16[2] as any)?.value ?? 0), 10) || 0;
    this.line17Amt = parseInt(String((this.form4562line17[2] as any)?.value ?? 0), 10) || 0;
    const line19HeadersAll = (list[10]?.dataRowList?.[0]?.dataCellList || []).slice(0);
    const line26HeadersAll = (list[27]?.dataRowList?.[0]?.dataCellList || []).slice(0);
    const line42HeadersAll = (list[34]?.dataRowList?.[0]?.dataCellList || []).slice(0);
    this.line19Headers = line19HeadersAll.splice(0, 8);
    this.line26Headers = line26HeadersAll.splice(0, 10);
    this.line42Headers = line42HeadersAll.splice(0, 7);
    this.line19DetHeader = list[11]?.dataRowList?.[0]?.dataCellList || [];
    this.line20DetHeader = list[21]?.dataRowList?.[0]?.dataCellList || [];
    this.line19AllDetails = [];
    for (let i = 12; i < 21; i++) {
      const lineDetails = (list[i]?.dataRowList?.[0]?.dataCellList || []).slice(0);
      if (lineDetails.length) {
        (lineDetails[4] as any).value = (lineDetails[4] as any)?.value == null ? 0 : parseInt((lineDetails[4] as any).value, 10);
        (lineDetails[5] as any).value = (lineDetails[5] as any)?.value == null ? 0 : parseInt((lineDetails[5] as any).value, 10);
        (lineDetails[6] as any).value = (lineDetails[6] as any)?.value == null ? 'HY' : (lineDetails[6] as any).value;
        (lineDetails[7] as any).value = (lineDetails[7] as any)?.value == null ? '150 DB' : (lineDetails[7] as any).value;
        (lineDetails[8] as any).value = (lineDetails[8] as any)?.value == null ? 0 : parseInt((lineDetails[8] as any).value, 10);
        this.line19AllDetails.push(lineDetails);
      }
    }
    this.line20AllDetails = [];
    for (let i = 22; i < 25; i++) {
      const lineDetails = (list[i]?.dataRowList?.[0]?.dataCellList || []).slice(0);
      if (lineDetails.length) {
        (lineDetails[4] as any).value = (lineDetails[4] as any)?.value == null ? 0 : parseInt((lineDetails[4] as any).value, 10);
        (lineDetails[5] as any).value = (lineDetails[5] as any)?.value == null ? 0 : parseInt((lineDetails[5] as any).value, 10);
        (lineDetails[6] as any).value = (lineDetails[6] as any)?.value == null ? 'HY' : (lineDetails[6] as any).value;
        (lineDetails[8] as any).value = (lineDetails[8] as any)?.value == null ? 0 : parseInt((lineDetails[8] as any).value, 10);
        this.line20AllDetails.push(lineDetails);
      }
    }
    this.totAmortAmtPerTaxRet = list[32]?.dataRowList?.[0]?.dataCellList || [];
    this.form4562line25 = list[26]?.dataRowList?.[0]?.dataCellList || [];
    this.line25Amt = parseInt(String((this.form4562line25[2] as any)?.value ?? 0), 10) || 0;
    this.totalDepExpPer4562 = list[28]?.dataRowList?.[0]?.dataCellList || [];
    this.unallocatedAmt = list[30]?.dataRowList?.[0]?.dataCellList || [];
    this.form4562line43 = list[35]?.dataRowList?.[0]?.dataCellList || [];
    this.line43Amt = parseInt(String((this.form4562line43[2] as any)?.value ?? 0), 10) || 0;
    const line26List = list[27]?.dataRowList || [];
    const line42List = list[34]?.dataRowList || [];
    this.form4562Line26Records = [];
    this.displayViewValue_26 = [];
    this.displayEditValue_26 = [];
    this.displayDeleteIcon_26 = [];
    this.formData_26 = { addrows: [], editrows: [], removerows: [] };
    if (line26List.length > 0) {
      const objId26 = line26List[0]?.rowDimensions?.object_id || '';
      const occ26 = objId26.split('~')[4];
      if (occ26 !== '0') {
        this.form4562Line26Records = this.modifyPropertyObjects(line26List.slice(0));
        this.form4562Line26RecordsCopy = JSON.parse(JSON.stringify(this.form4562Line26Records));
        this.form4562Line26Records.forEach((value: any) => {
          this.displayViewValue_26.push(true);
          this.displayEditValue_26.push(false);
          this.displayDeleteIcon_26.push(true);
          if (value.dataCellList[2]?.value !== 'VARIOUS' && value.dataCellList[2]?.value)
            value.dataCellList[2].value = new Date(value.dataCellList[2].value);
          this.depreDed26 += parseInt(String(value.dataCellList[10]?.value ?? 0), 10) || 0;
          const y = (value.rowDimensions?.object_id || '').split('~');
          const transDetailKey = y[3];
          const occ = y[4];
          const clonedRecordData = this.recordData_26.map((c: any) => ({ ...c, trans_dtls_key: transDetailKey, occurence: occ }));
          this.formData_26.editrows.push(clonedRecordData);
        });
      }
    }
    this.form4562Line42Records = [];
    this.displayViewValue_42 = [];
    this.displayEditValue_42 = [];
    this.displayDeleteIcon_42 = [];
    this.formData_42 = { addrows: [], editrows: [], removerows: [] };
    if (line42List.length > 0) {
      const objId42 = line42List[0]?.rowDimensions?.object_id || '';
      const occ42 = objId42.split('~')[4];
      if (occ42 !== '0') {
        this.form4562Line42Records = line42List.slice(0);
        this.form4562Line42RecordsCopy = JSON.parse(JSON.stringify(this.form4562Line42Records));
        this.form4562Line42RecordsOrig = line42List.slice(0);
        this.form4562Line42Records.forEach((value: any) => {
          this.displayViewValue_42.push(true);
          this.displayEditValue_42.push(false);
          this.displayDeleteIcon_42.push(true);
          if (value.dataCellList[2]?.value !== 'VARIOUS' && value.dataCellList[2]?.value)
            value.dataCellList[2].value = new Date(value.dataCellList[2].value);
          const y = (value.rowDimensions?.object_id || '').split('~');
          const transDetailKey = y[3];
          const occ = y[4];
          const clonedRecordData = this.recordData_42.map((c: any) => ({ ...c, trans_dtls_key: transDetailKey, occurence: occ }));
          this.formData_42.editrows.push(clonedRecordData);
        });
      }
    }
    this.formData_line14.editrows = [[{ Attribute_Value: this.line14Amt, Attribute_Name: 'DEPRECIATION_DEDUCTION', is_dirty: 'N', occurence: 1 }]];
    this.formData_line16.editrows = [[{ Attribute_Value: this.line16Amt, Attribute_Name: 'DEPRECIATION_DEDUCTION', is_dirty: 'N', occurence: 1 }]];
    this.formData_line17.editrows = [[{ Attribute_Value: this.line17Amt, Attribute_Name: 'DEPRECIATION_DEDUCTION', is_dirty: 'N', occurence: 1 }]];
    this.formData_line25.editrows = [[{ Attribute_Value: this.line25Amt, Attribute_Name: 'DEPRECIATION_DEDUCTION', is_dirty: 'N', occurence: 1 }]];
    this.formData_line43.editrows = [[{ Attribute_Value: this.line43Amt, Attribute_Name: 'AMORTIZATION_FOR_THIS_YEAR', is_dirty: 'N', occurence: 1 }]];
    let line19DepDed = 0;
    this.line19AllDetails.forEach((row: any) => { line19DepDed += parseInt(String(row[8]?.value ?? 0), 10) || 0; });
    let line20DepDed = 0;
    this.line20AllDetails.forEach((row: any) => { line20DepDed += parseInt(String(row[8]?.value ?? 0), 10) || 0; });
    const deltaDepr = this.line14Amt + this.line16Amt + this.line17Amt + line19DepDed + line20DepDed + this.line25Amt + this.depreDed26;
    if (this.totalDepExpPer4562[1]) (this.totalDepExpPer4562[1] as any).value = deltaDepr;
    const tbVal = parseInt(String(this.form4562DepExpPerTaxRet[1]?.value ?? 0), 10) || 0;
    if (this.unallocatedAmt[1]) (this.unallocatedAmt[1] as any).value = tbVal - deltaDepr;
    if (this.totAmortAmtPerTaxRet[1] && (this.totAmortAmtPerTaxRet[1] as any).value == null) (this.totAmortAmtPerTaxRet[1] as any).value = 0;
  }

  private initFormViewData(): void {
    this.FormViewData = {
      partI: { title: 'Election To Expense Certain Property Under Section 179', columns: ['Form 4562 Line', 'Description', 'Amount'], rows: [] },
      partII: { title: 'Special Depreciation Allowance and Other Depreciation', rows: [{ num: '14', value: 'Special depreciation allowance...' }, { num: '15', value: 'Property subject to section 168(f)(1) election' }, { num: '16', value: 'Other depreciation (including ACRS)' }] },
      partIII: { title: 'MACRS Depreciation', table: [{ num: '17', value: '...' }, { num: '18', value: '...' }], sections: [] },
      partIV: { title: 'Summary', rows: [{ num: '21', value: '...' }, { num: '22', value: '...' }, { num: '23', value: '...' }] },
      partV: { title: 'Listed Property', rows: [], section1: { columns: [], rows: [] }, sections: [], sectionB2: { title: '', columns: [], rows: [] } },
      partVI: { title: 'Amortization', columns: ['(a) Description of costs', '(b) Date amortization begins', '(c) Amortizable amount', '(d) Code section', '(e) Amortization period or percentage', '(f) Amortization for this year'], rows: [{ num: '42', value: '...' }, { num: '43', value: '...' }, { num: '44', value: '...' }] }
    };
  }

  setDepDeduct(line_no: string, edit: boolean, index: number): void {
    let temp02 = 0;
    let temp2E = 0;
    if (line_no === '14' || line_no === '16' || line_no === '17' || line_no === '19a' || line_no === '19b' || line_no === '19c' || line_no === '19d' || line_no === '19e' || line_no === '19f' || line_no === '19g' || line_no === '19h' || line_no === '19i' || line_no === '20a' || line_no === '20b' || line_no === '20c' || line_no === '25' || line_no === '26') {
      let deltaDepr = this.line14Amt + this.line16Amt + this.line17Amt;
      this.line19AllDetails.forEach((r: any) => { deltaDepr += parseInt(String(r[8]?.value ?? 0), 10) || 0; });
      this.line20AllDetails.forEach((r: any) => { deltaDepr += parseInt(String(r[8]?.value ?? 0), 10) || 0; });
      deltaDepr += this.line25Amt;
      if (this.formData_26.addrows.length > 0 && this.formData_26.addrows[index]) {
        const v = parseInt(String(this.formData_26.addrows[index][9]?.Attribute_Value ?? 0), 10) || 0;
        this.form4562Amounts[0][index] = v;
        this.form4562Amounts[0].forEach((val: any) => { temp02 += parseInt(String(val), 10) || 0; });
      }
      this.temp02 = temp02;
      this.form4562Line26Records.forEach((value: any) => { temp2E += parseInt(String(value.dataCellList[10]?.value ?? 0), 10) || 0; });
      this.temp2E = temp2E;
      if (this.totalDepExpPer4562[1]) (this.totalDepExpPer4562[1] as any).value = deltaDepr + this.temp02 + this.temp2E;
      const tbVal = parseInt(String(this.form4562DepExpPerTaxRet[1]?.value ?? 0), 10) || 0;
      if (this.unallocatedAmt[1]) (this.unallocatedAmt[1] as any).value = tbVal - (deltaDepr + this.temp02 + this.temp2E);
    } else if (line_no === '42') {
      if (!edit && this.formData_42.addrows[index]) {
        const amortization42 = parseInt(String(this.formData_42.addrows[index][5]?.Attribute_Value ?? 0), 10) || 0;
        this.form4562Amounts[1][index] = amortization42;
      }
    } else if (line_no === '26' && edit && this.form4562Line26Records[index]) {
      if (this.totalDepExpPer4562[1]) (this.totalDepExpPer4562[1] as any).value = (this.totalDepExpPer4562[1] as any).value - parseInt(String(this.form4562Line26Records[index].dataCellList[10]?.value ?? 0), 10) + parseInt(String(this.form4562Line26Records[index].dataCellList[10]?.value ?? 0), 10);
    } else if (line_no === '43') {
      // recalc if needed
    }
    this.cdr.detectChanges();
  }

  lineItemChange(line_no: string, rowIndex: number, colIndex: number): void {
    if (line_no === '14' && this.formData_line14.editrows?.[0]?.[0]) {
      (this.formData_line14.editrows[0][0] as any).Attribute_Value = this.line14Amt; (this.formData_line14.editrows[0][0] as any).is_dirty = 'Y';
    }
    if (line_no === '16' && this.formData_line16.editrows?.[0]?.[0]) {
      (this.formData_line16.editrows[0][0] as any).Attribute_Value = this.line16Amt; (this.formData_line16.editrows[0][0] as any).is_dirty = 'Y';
    }
    if (line_no === '17' && this.formData_line17.editrows?.[0]?.[0]) {
      (this.formData_line17.editrows[0][0] as any).Attribute_Value = this.line17Amt; (this.formData_line17.editrows[0][0] as any).is_dirty = 'Y';
    }
    if (line_no === '25' && this.formData_line25.editrows?.[0]?.[0]) {
      (this.formData_line25.editrows[0][0] as any).Attribute_Value = this.line25Amt; (this.formData_line25.editrows[0][0] as any).is_dirty = 'Y';
    }
    if (line_no === '43' && this.formData_line43.editrows?.[0]?.[0]) {
      (this.formData_line43.editrows[0][0] as any).Attribute_Value = this.line43Amt; (this.formData_line43.editrows[0][0] as any).is_dirty = 'Y';
    }
    if (line_no === '26' && this.form4562Line26Records[rowIndex]) {
      const cell = this.form4562Line26Records[rowIndex].dataCellList[colIndex + 1];
      if (this.formData_26.editrows[rowIndex] && this.formData_26.editrows[rowIndex][colIndex]) {
        (this.formData_26.editrows[rowIndex][colIndex] as any).Attribute_Value = cell?.value;
        (this.formData_26.editrows[rowIndex][colIndex] as any).is_dirty = 'Y';
      }
    }
    if (line_no === '42' && this.form4562Line42Records[rowIndex]) {
      const cell = this.form4562Line42Records[rowIndex].dataCellList[colIndex + 1];
      if (this.formData_42.editrows[rowIndex] && this.formData_42.editrows[rowIndex][colIndex]) {
        (this.formData_42.editrows[rowIndex][colIndex] as any).Attribute_Value = cell?.value;
        (this.formData_42.editrows[rowIndex][colIndex] as any).is_dirty = 'Y';
      }
    }
    this.cdr.detectChanges();
  }

  AssetChange(): void { this.cdr.detectChanges(); }
  errorChange(line: number, index: number, col: number): void {
    if (line === 26) this.setDepDeduct('26', false, index);
    if (line === 42) this.setDepDeduct('42', false, index);
    this.cdr.detectChanges();
  }

  addSection(line_no: number): void {
    if (line_no === 26) { this.data.partV.rows.push({}); this.formData_26.addrows.push(JSON.parse(JSON.stringify(this.recordData_26))); }
    if (line_no === 42) { this.data.partVI.rows.push({}); this.formData_42.addrows.push(JSON.parse(JSON.stringify(this.recordData_42))); }
    this.cdr.detectChanges();
  }

  sectionRemove(line: number, index: number): void {
    if (line === 26) {
      this.data.partV.rows.splice(index, 1);
      const depDeduction = this.formData_26.addrows[index]?.[9]?.Attribute_Value ?? 0;
      if (this.totalDepExpPer4562[1]) (this.totalDepExpPer4562[1] as any).value = parseInt(String((this.totalDepExpPer4562[1] as any).value), 10) - parseInt(String(depDeduction), 10);
      if (this.unallocatedAmt[1]) (this.unallocatedAmt[1] as any).value = parseInt(String((this.unallocatedAmt[1] as any).value), 10) + parseInt(String(depDeduction), 10);
      this.formData_26.addrows.splice(index, 1);
    }
    if (line === 42) {
      this.data.partVI.rows.splice(index, 1);
      const depDeduction = this.formData_42.addrows[index]?.[5]?.Attribute_Value ?? 0;
      if (this.totalDepExpPer4562[1]) (this.totalDepExpPer4562[1] as any).value = parseInt(String((this.totalDepExpPer4562[1] as any).value), 10) - parseInt(String(depDeduction), 10);
      if (this.unallocatedAmt[1]) (this.unallocatedAmt[1] as any).value = parseInt(String((this.unallocatedAmt[1] as any).value), 10) + parseInt(String(depDeduction), 10);
      this.formData_42.addrows.splice(index, 1);
    }
    this.cdr.detectChanges();
  }

  pencilButtonClicked(line: number, index: number, _object_id: string): void {
    if (line === 26) {
      this.displayViewValue_26[index] = !this.displayViewValue_26[index];
      this.displayEditValue_26[index] = !this.displayEditValue_26[index];
      this.displayDeleteIcon_26[index] = this.displayViewValue_26[index];
    }
    if (line === 42) {
      this.displayViewValue_42[index] = !this.displayViewValue_42[index];
      this.displayEditValue_42[index] = !this.displayEditValue_42[index];
      this.displayDeleteIcon_42[index] = this.displayViewValue_42[index];
    }
    this.cdr.detectChanges();
  }

  removeExistingRecord(line: number, index: number, object_id: string): void {
    const x = object_id.split('~');
    const occurrence = x[4];
    const transDetailKey = x[3];
    const removeRow = { tax_year: this.taxYear, trans_type_key: 9, combination_key: this.combinationKey, group_obj_key: 201473, form_key: 3, line_no: line, occurence: occurrence, trans_dtls_key: transDetailKey, trans_status: 'A' };
    if (line === 26) {
      this.formData_26.removerows.push(removeRow);
      const depDeduction = this.form4562Line26Records[index]?.dataCellList[10]?.value ?? 0;
      if (this.totalDepExpPer4562[1]) (this.totalDepExpPer4562[1] as any).value = parseInt(String((this.totalDepExpPer4562[1] as any).value), 10) - parseInt(String(depDeduction), 10);
      if (this.unallocatedAmt[1]) (this.unallocatedAmt[1] as any).value = parseInt(String((this.unallocatedAmt[1] as any).value), 10) + parseInt(String(depDeduction), 10);
      this.form4562Line26Records.splice(index, 1);
      this.displayViewValue_26.splice(index, 1);
      this.displayEditValue_26.splice(index, 1);
      this.displayDeleteIcon_26.splice(index, 1);
      this.formData_26.editrows.splice(index, 1);
    }
    if (line === 42) {
      this.formData_42.removerows.push(removeRow);
      this.form4562Line42Records.splice(index, 1);
      this.displayViewValue_42.splice(index, 1);
      this.displayEditValue_42.splice(index, 1);
      this.displayDeleteIcon_42.splice(index, 1);
      this.formData_42.editrows.splice(index, 1);
    }
    this.gtwSnackbarService.openSnackBar("Please click on 'Save and Proceed' to Delete this Transaction. Otherwise click on 'Cancel'", 'gtw-snackbar--yellow');
    this.cdr.detectChanges();
  }

  modifyPropertyObjects(propertyObjects: any[]): any[] {
    const cloned = JSON.parse(JSON.stringify(propertyObjects));
    cloned.forEach((value: any) => {
      const cell7 = value.dataCellList[7];
      if (cell7?.value && String(cell7.value).includes('~')) {
        const parts = String(cell7.value).split('~');
        value.dataCellList[7] = { ...cell7, value: parts[0] };
        value.dataCellList.splice(8, 0, { ...cell7, value: parts[1] || '' });
      }
    });
    return cloned;
  }

  convertDate(dateObject: Date | string | null): string | null {
    if (!dateObject) return null;
    const d = dateObject instanceof Date ? dateObject : new Date(dateObject);
    if (isNaN(d.getTime())) return null;
    const month = (d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : String(d.getMonth() + 1);
    const date = d.getDate() < 10 ? '0' + d.getDate() : String(d.getDate());
    return month + '/' + date + '/' + d.getFullYear();
  }

  row_is_dirty(row: any[]): boolean {
    return (row || []).some((r: any) => Array.isArray(r) ? r.some((c: any) => c?.is_dirty === 'Y') : (r?.is_dirty === 'Y'));
  }
  isDirty(row: any[]): boolean {
    return (row || []).some((r: any) => r?.is_dirty === 'Y');
  }

  save(): void {
    if (this.crudLoading) return;
    this.crudLoading = true;
    this.isSaveClicked = true;
    this.cdr.detectChanges();
    const formDataAggregate = { addrows: [] as any[], editrows: [] as any[], removerows: [] as any[] };
    if (this.formData_line14.editrows?.[0]?.[0]?.is_dirty === 'Y') formDataAggregate.editrows.push(this.formData_line14.editrows[0]);
    if (this.formData_line16.editrows?.[0]?.[0]?.is_dirty === 'Y') formDataAggregate.editrows.push(this.formData_line16.editrows[0]);
    if (this.formData_line17.editrows?.[0]?.[0]?.is_dirty === 'Y') formDataAggregate.editrows.push(this.formData_line17.editrows[0]);
    if (this.formData_line25.editrows?.[0]?.[0]?.is_dirty === 'Y') formDataAggregate.editrows.push(this.formData_line25.editrows[0]);
    if (this.formData_line43.editrows?.[0]?.[0]?.is_dirty === 'Y') formDataAggregate.editrows.push(this.formData_line43.editrows[0]);
    this.formData_26.addrows.forEach((value: any[]) => { formDataAggregate.addrows.push(JSON.parse(JSON.stringify(value))); });
    this.formData_26.editrows.forEach((value: any[]) => { if (this.isDirty(value)) formDataAggregate.editrows.push(JSON.parse(JSON.stringify(value))); });
    this.formData_26.removerows.forEach((r: any) => formDataAggregate.removerows.push(r));
    this.formData_42.addrows.forEach((value: any[]) => formDataAggregate.addrows.push(JSON.parse(JSON.stringify(value))));
    this.formData_42.editrows.forEach((value: any[]) => { if (this.isDirty(value)) formDataAggregate.editrows.push(JSON.parse(JSON.stringify(value))); });
    this.formData_42.removerows.forEach((r: any) => formDataAggregate.removerows.push(r));
    formDataAggregate.addrows.forEach((item: any) => item.forEach((c: any) => c.form_key = this.v_form_key));
    formDataAggregate.editrows.forEach((item: any) => item.forEach((c: any) => c.form_key = this.v_form_key));
    formDataAggregate.removerows.forEach((r: any) => r.form_key = this.v_form_key);
    const mainData = [formDataAggregate];
    const baseUrl = this.GENERAL_CONFIG?.base_url || this.baseURLs?.api || '';
    const enrichedGS = this.buildSaveGlobalService();
    this.form4562Service.save4562Form(baseUrl, mainData, this.rowData, enrichedGS, this.filterParams).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: (response: any) => {
        this.crudLoading = false;
        this.isSaveClicked = false;
        if (response?.callSuccess === '1' && response?.errorMessage === 'null') {
          this.gtwSnackbarService.openSnackBar('Transactions saved successfully', 'gtw-snackbar--green');
          this.requestGridUpdate.emit('refresh');
        } else if (response?.jsonObject && response.jsonObject.length > 0) {
          this.gtwSnackbarService.openSnackBar('Please correct the errors below', 'gtw-snackbar--red');
        } else {
          this.gtwSnackbarService.openSnackBar(response?.errorMessage || 'Error saving form', 'gtw-snackbar--red');
        }
        this.cdr.detectChanges();
      },
      error: () => {
        this.crudLoading = false;
        this.isSaveClicked = false;
        this.gtwSnackbarService.openSnackBar('Error occurred while saving. Please try again.', 'gtw-snackbar--red');
        this.cdr.detectChanges();
      }
    });
  }

  private buildSaveGlobalService(): any {
    const gs = { ...(this.globalService || {}), globalParams: this.globalService?.globalParams || this.globalService };
    const fp = this.filterParams || {};
    const rd = this.rowData || {};
    if (!gs.scenarioCode) gs.scenarioCode = fp.scenarioCode || fp.scenario_code || 'RAF';
    if (!gs.is_issue_key_enabled) gs.is_issue_key_enabled = fp.is_issue_key_enabled || 'N';
    if (!gs.checkLockedbj) {
      const scenario = fp.scenario ?? gs.scenario ?? rd.SCENARIO;
      gs.checkLockedbj = JSON.stringify([{ leid: rd.LEID || '', cdr_number: rd.CDR_NO || rd.MARS || '', consol_group_key: String(rd.CONSOL_GROUP_KEY || ''), reporting_period: String(rd.REPORTING_PERIOD || 1), combination_key: String(rd.COMBINATION_KEY || ''), scenario_key: parseInt(String(scenario), 10) || 0 }]);
    }
    return gs;
  }

  reset(): void { this.loadData(); }
  cancel(): void { this.requestGridUpdate.emit('cancel'); }
}
